import CheckboxFieldsList from "../../../../../components/ticketing/checkboxFieldsList/CheckboxFieldsList";
import CustomFieldsForm from "../../../../../components/ticketing/customFieldsForm/CustomFieldsForm";
import QuesAnswerForm from "../../../../../components/ticketing/quesAnswerForm/QuesAnswerForm";
import TicketingSettingsModal from "./TicketingSettingsModal";

function FormFieldsSettingsModal({
  event,
  eventErrors,
  handleDeleteField,
  handleFieldChange,
  handleUpdateCustomFields,
  isEditing,
  newCustomFieldError,
  onClose,
  t,
  updateState,
  validateNewCustomField,
}) {
  const questions = Array.isArray(event.ansQues) && event.ansQues.length > 0 ? event.ansQues : [];

  return (
    <TicketingSettingsModal
      description={t("formSettingsDescription")}
      eyebrow={t("formSettingsEyebrow")}
      labelledBy="ticketing-form-settings-title"
      onClose={onClose}
      t={t}
      title={isEditing ? t("updateForm") : t("createForm")}
    >
      <div className="ticketingSettingsModalBody">
        <div className="formSettingsSection">
          <h3>{t("participantFieldsTitle")}</h3>
          <p>{t("participantFieldsDescription")}</p>
        </div>

        <CheckboxFieldsList
          fields={event.formFields.mandatoryFields}
          name={t("mandatoryFields")}
          onChange={(field, value) => handleFieldChange(field, value, "mandatoryFields")}
          locked
        />

        <CheckboxFieldsList
          fields={event.formFields.optionnalFields}
          name={t("optionalFields")}
          onChange={(field, value) => handleFieldChange(field, value, "optionnalFields")}
        />

        <CustomFieldsForm
          handleFieldsChange={(name, isMandatory) => handleUpdateCustomFields(name, isMandatory)}
          handleNewField={validateNewCustomField}
          newCustomFieldError={newCustomFieldError}
          customFields={event.formFields.customFields}
          handleDeleteField={(value) => handleDeleteField(value, "customFields")}
        />

        <QuesAnswerForm
          questions={questions}
          setQuestion={(value) => updateState("ansQues", value)}
          error={eventErrors.ansQues}
        />

        <section className="kioskFormOptions">
          <div>
            <h2 className="sectionSubtitle">{t("kioskFormOptionsTitle")}</h2>
            <p className="sectionDescription">{t("kioskFormOptionsDescription")}</p>
          </div>

          <div>
            <p className="sectionTitle">{t("kioskRequireFullFormLabel")}</p>
            <div className="buttonsContainer">
              <button
                type="button"
                className={`button ${event?.formRequiredOnSite ? "active" : ""}`}
                onClick={() => updateState("formRequiredOnSite", true)}
              >
                {t("yes")}
              </button>
              <button
                type="button"
                className={`button ${event?.formRequiredOnSite ? "" : "active"}`}
                onClick={() => updateState("formRequiredOnSite", false)}
              >
                {t("no")}
              </button>
            </div>
          </div>
        </section>
      </div>
    </TicketingSettingsModal>
  );
}

export default FormFieldsSettingsModal;
